import { GridItem, SimpleGrid } from '@chakra-ui/react';

import { FeatureContentTemplate } from '@/modules/shared';
import YouTubePlayer from 'react-player/youtube';
import { CustomPortableText } from '@/modules/sanity-studio/components';
import type { PortableTextBlock } from 'next-sanity';
import { DefaultStyle } from '@packages/wastic-shared';

type HomeAboutProps = {
	title:       string;
	description: PortableTextBlock[];
	youtubeUrl:  string;
};

const HomeAbout = ({
	title,
	description,
	youtubeUrl,
}: HomeAboutProps) => {
	return (
		<SimpleGrid
			alignItems={'center'}
			columns={{
				base: 1,
				xl:   2,
			}}
			gap={DefaultStyle.GRID_GAP}
		>
			<GridItem>
				<YouTubePlayer controls url={youtubeUrl} width={'100%'} />
			</GridItem>
			<GridItem>
				<FeatureContentTemplate title={title}>
					<CustomPortableText textStyle={'p2'} value={description} />
				</FeatureContentTemplate>
			</GridItem>
		</SimpleGrid>
	);
};

export default HomeAbout;